// project imports
// action - state management
import * as actionTypes from "../../actions/actionTypes";
import { getUnitSymbolByUnit, itemType, unitType } from "../types";
import { years } from "store/utils/years";
import { OTHER_ADVERTISEMENT_AND_MARKETING_EXPENSES_REDUCER_KEY } from "..";
import {
  appStoreSalesMonths,
  appStoresTotalMonth,
} from "../revenue/staticMonthsData";
import {
  gae_fixedAssetMonth,
  oame_analyticsAndEngagementTool,
  oame_mailingMonth,
  same_marketingExpensesMonths,
  same_seoMonths,
} from "./staticYearsData";

// This is to filter based on company types
import { SaaSCoType, GeneralCoType } from "constants/companyTypes";

const prefix = "oame_";

// other revenue keys
export const OTHER_ADVERTISEMENT_AND_MARKETING_EXPENSES_INNER_TITLE_KEY =
  prefix + "innerTitle";
export const OTHER_ADVERTISEMENT_AND_MARKETING_EXPENSES_KEY =
  prefix + "otherAdvAndMarketing";
export const ATTRIBUTION_TOOL_KEY = prefix + "attributionTool";
export const ANALYTICS_AND_ENGAGEMENT_TOOL_KEY =
  prefix + "analyticsAndEngagementTool";
export const MAILING_KEY = prefix + "mailing";
export const CUSTOMER_SUPPORT_KEY = prefix + "customerSupport";
export const SPONSORSHIP_KEY = prefix + "sponsorship";
export const OTHER_KEY = prefix + "other";

export const otherAdvAndMarketingExpenseItems = [
  OTHER_ADVERTISEMENT_AND_MARKETING_EXPENSES_INNER_TITLE_KEY,
  OTHER_ADVERTISEMENT_AND_MARKETING_EXPENSES_KEY,
  ATTRIBUTION_TOOL_KEY,
  ANALYTICS_AND_ENGAGEMENT_TOOL_KEY,
  MAILING_KEY,
  CUSTOMER_SUPPORT_KEY,
  SPONSORSHIP_KEY,
  OTHER_KEY,
];

export const initialState = {
  [OTHER_ADVERTISEMENT_AND_MARKETING_EXPENSES_INNER_TITLE_KEY]: {
    title: "Other Advertisement & Marketing Expenses",
    unit: unitType.INNER_TITLE,
    unitSymbol: getUnitSymbolByUnit(unitType.INNER_TITLE),
    initialPeriod: 0,
    initialPeriodMonth: 0,
    type: itemType.INNER_TITLE,
    companyTypes: [SaaSCoType, GeneralCoType],
    calculate: (
      yearKey,
      getReducerFunc,
      companyType = null,
      instanceId = null
    ) => {
      return "";
    },
    months: appStoreSalesMonths,
    years: {
      [years.YEAR_1_KEY]: "",
      [years.YEAR_2_KEY]: "",
      [years.YEAR_3_KEY]: "",
      [years.YEAR_4_KEY]: "",
      [years.YEAR_5_KEY]: "",
    },
  },
  [OTHER_ADVERTISEMENT_AND_MARKETING_EXPENSES_KEY]: {
    title: "Total",
    unit: unitType.MONEY,
    unitSymbol: getUnitSymbolByUnit(unitType.MONEY),
    initialPeriod: 0,
    initialPeriodMonth: 0,
    type: itemType.CALCULATION,
    companyTypes: [SaaSCoType, GeneralCoType],
    calculate: (
      yearKey,
      getReducerFunc,
      companyType = null,
      instanceId = null
    ) => {
      let result = 0;
      for (let i = 2; i < otherAdvAndMarketingExpenseItems.length; i++) {
        result += Number(
          getReducerFunc(
            OTHER_ADVERTISEMENT_AND_MARKETING_EXPENSES_REDUCER_KEY
          )[otherAdvAndMarketingExpenseItems[i]]["years"][yearKey]
        );
      }
      return result;
    },
    months: same_marketingExpensesMonths,
    years: {
      [years.YEAR_1_KEY]: 0,
      [years.YEAR_2_KEY]: 0,
      [years.YEAR_3_KEY]: 0,
      [years.YEAR_4_KEY]: 0,
      [years.YEAR_5_KEY]: 0,
    },
  },
  [ATTRIBUTION_TOOL_KEY]: {
    title: "Attribution Tool",
    unit: unitType.MONEY,
    unitSymbol: getUnitSymbolByUnit(unitType.MONEY),
    initialPeriod: 0,
    initialPeriodMonth: 0,
    type: itemType.INPUT,
    companyTypes: [SaaSCoType, GeneralCoType],
    calculate: (
      yearKey,
      getReducerFunc,
      companyType = null,
      instanceId = null
    ) => {
      return 0;
    },
    months: gae_fixedAssetMonth,
    years: {
      [years.YEAR_1_KEY]: 400,
      [years.YEAR_2_KEY]: 400,
      [years.YEAR_3_KEY]: 400,
      [years.YEAR_4_KEY]: 400,
      [years.YEAR_5_KEY]: 400,
    },
  },
  [ANALYTICS_AND_ENGAGEMENT_TOOL_KEY]: {
    title: "Analytics & Engagement Tool",
    unit: unitType.MONEY,
    unitSymbol: getUnitSymbolByUnit(unitType.MONEY),
    initialPeriod: 0,
    initialPeriodMonth: 0,
    type: itemType.INPUT,
    companyTypes: [SaaSCoType, GeneralCoType],
    calculate: (
      yearKey,
      getReducerFunc,
      companyType = null,
      instanceId = null
    ) => {
      return 0;
    },
    months: oame_analyticsAndEngagementTool,
    years: {
      [years.YEAR_1_KEY]: 200,
      [years.YEAR_2_KEY]: 200,
      [years.YEAR_3_KEY]: 200,
      [years.YEAR_4_KEY]: 200,
      [years.YEAR_5_KEY]: 200,
    },
  },
  [MAILING_KEY]: {
    title: "Mailing",
    unit: unitType.MONEY,
    unitSymbol: getUnitSymbolByUnit(unitType.MONEY),
    initialPeriod: 0,
    initialPeriodMonth: 0,
    type: itemType.INPUT,
    companyTypes: [SaaSCoType, GeneralCoType],
    calculate: (
      yearKey,
      getReducerFunc,
      companyType = null,
      instanceId = null
    ) => {
      return 0;
    },
    months: oame_mailingMonth,
    years: {
      [years.YEAR_1_KEY]: 75,
      [years.YEAR_2_KEY]: 75,
      [years.YEAR_3_KEY]: 75,
      [years.YEAR_4_KEY]: 75,
      [years.YEAR_5_KEY]: 75,
    },
  },
  [CUSTOMER_SUPPORT_KEY]: {
    title: "Customer Support",
    unit: unitType.MONEY,
    unitSymbol: getUnitSymbolByUnit(unitType.MONEY),
    initialPeriod: 0,
    initialPeriodMonth: 0,
    type: itemType.INPUT,
    companyTypes: [SaaSCoType, GeneralCoType],
    calculate: (
      yearKey,
      getReducerFunc,
      companyType = null,
      instanceId = null
    ) => {
      return 0;
    },
    months: appStoresTotalMonth,
    years: {
      [years.YEAR_1_KEY]: 100,
      [years.YEAR_2_KEY]: 100,
      [years.YEAR_3_KEY]: 100,
      [years.YEAR_4_KEY]: 100,
      [years.YEAR_5_KEY]: 100,
    },
  },
  [SPONSORSHIP_KEY]: {
    title: "Sponsorship",
    unit: unitType.MONEY,
    unitSymbol: getUnitSymbolByUnit(unitType.MONEY),
    initialPeriod: 0,
    initialPeriodMonth: 0,
    type: itemType.INPUT,
    companyTypes: [SaaSCoType, GeneralCoType],
    calculate: (
      yearKey,
      getReducerFunc,
      companyType = null,
      instanceId = null
    ) => {
      return 0;
    },
    months: same_seoMonths,
    years: {
      [years.YEAR_1_KEY]: 250,
      [years.YEAR_2_KEY]: 250,
      [years.YEAR_3_KEY]: 250,
      [years.YEAR_4_KEY]: 250,
      [years.YEAR_5_KEY]: 250,
    },
  },
  [OTHER_KEY]: {
    title: "Other",
    unit: unitType.MONEY,
    unitSymbol: getUnitSymbolByUnit(unitType.MONEY),
    initialPeriod: 0,
    initialPeriodMonth: 0,
    type: itemType.INPUT,
    companyTypes: [SaaSCoType, GeneralCoType],
    calculate: (
      yearKey,
      getReducerFunc,
      companyType = null,
      instanceId = null
    ) => {
      return 0;
    },
    months: appStoresTotalMonth,
    years: {
      [years.YEAR_1_KEY]: 100,
      [years.YEAR_2_KEY]: 100,
      [years.YEAR_3_KEY]: 100,
      [years.YEAR_4_KEY]: 100,
      [years.YEAR_5_KEY]: 100,
    },
  },
};

// ==============================|| SUBSCRIPTION ACQUISITION ASSUMPTIONS REDUCER ||============================== //

const otherAdvertisementAndMarketingExpenseReducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case actionTypes.SET_OTHER_ADVERTISEMENT_AND_MARKETING_EXPENSE_BY_YEAR:
      return {
        ...state,
        [action.key]: {
          ...state[action.key],
          years: {
            ...state[action.key].years,
            [action.yearKey]: [action.amount],
          },
        },
      };
    case actionTypes.SET_OTHER_ADVERTISEMENT_AND_MARKETING_EXPENSE_BY_MONTH:
      return {
        ...state,
        [action.key]: {
          ...state[action.key],
          months: {
            ...state[action.key].months,
            [action.yearKey]: [action.amount],
          },
        },
      };
    case actionTypes.REPLACE_OTHER_ADVERTISEMENT_AND_MARKETING_EXPENSE_YEARS:
      return {
        ...state,
        [action.key]: {
          ...state[action.key],
          months: action?.payload,
        },
      };
    case actionTypes.RESET_OTHER_ADVERTISEMENT_AND_MARKETING_EXPENSE_REDUCER:
      return initialState;
    default:
      return state;
  }
};

export default otherAdvertisementAndMarketingExpenseReducer;
